import React from "react"
import modStyl from '../terms-of-service/index.module.scss'

const PrivacyPolicy = ()=> {
  return (
    <div className={modStyl.greeWrap}>
      <div className={modStyl.title}>《科研数据小助手用户隐私政策》</div><br />
      <div className={modStyl.section}>
          我们尊重并保护所有用户的个人信息安全及隐私权，我们会按照本个人信息保护政策（“本政策”）的规定收集、使用、存储和披露您的个人信息，及按法律法规要求确保您所享有的相关权利，并采取安全保护措施保护您的用户信息安全可控，同时我们也会不时更新本政策。
      </div>
      <div className={modStyl.section}>
          请您在使用我们的各项服务前务必仔细阅读并透彻理解本隐私政策。如果您选择使用或继续使用我们的服务，即意味着同意我们根据本政策的约定处理您的相关信息。如您不同意本政策中的任何内容，您应当立即停止使用我们的服务。如您阅读完后有任何问题，您可以通过邮件edc@huimeihealth.com.cn反馈渠道联系我们，我们会尽快为您作出解答。
      </div>
      <br />（一）信息的收集使用规则<br />
      <br />1.我们收集哪些您的个人信息。
      <br />(1)在您使用我们的服务的过程中，我们可能会收集您的手机号码、省份，医院，科室、职称、患者信息、患者年龄、患者性别、患者病情、浏览器类型、设备信息、日志信息等。尤其是对于必须是由特殊身份用户才能参与的服务，我们必须收集您的个人敏感身份信息，包含姓名、手机号、省份、医院、科室、职称、身份证、银行账号、开户行等个人敏感信息。在具体的服务中，我们将向您阐明原因和内容范围，并征得您的单独、明示同意；
      <br />(2)为了保障您更好地使用我们的服务，您需要对前述上传的信息，作出如下承诺和保证：
      <br />①您所在的医疗机构、单位或其他组织未对您参与使用我们的服务、项目、调研等作出任何禁止性规定。
      <br />②您所填写的有关患者的相关信息（包括一般个人信息、敏感个人信息），均已按照《个人信息保护法》及其他相关法律、法规的要求向患者履行告知义务，并已按照法律规定获得患者的明示、单独同意。
      <br />(3)为向您提供上述服务，我们可能会调用您设备中的访问及使用权限。在您使用相应功能时会看到弹窗提醒，询问您是否授权，您也可以在设备的设置功能中选择关闭部分或全部权限。
      <br />(4)您需要注意的是，如果您拒绝授权相关权限或拒绝提供相关信息，我们可能无法为您提供该项权限或相关信息对应的特定功能，但您仍可正常使用我们产品或服务的其他功能；
      <br />(5)为了您可以正确使用工具，首次使用工具时，需要您阅读和同意用户需知。我们会记录您是否阅读并同意了用户需知，以便您可以更加准确的使用我们的工具；
      <br />(6)我们将会在本政策所涵盖的用途内使用收集的信息。个人信息的处理目的、处理方式和处理的个人信息种类发生变更时，我们将重新取得您的同意。
      <br />2.我们如何使用您的个人信息
      <br />我们严格遵守法律法规的规定及与用户的约定，将收集的信息按照本政策的规定用于以下用途。
      <br />(1)提供、维护及优化本程序服务：我们会利用收集的信息来提供和优化改进本程序服务，例如，跟踪用户向我们报告的问题，以及根据服务使用信息向用户提供更优质的服务。
      <br />(2)安全保障：我们会利用相关信息协助提升本程序服务的安全性和可靠性，包括检测、防范和应对可能危害用户或公众的欺诈行为、滥用行为、非法行为、安全风险和技术问题等。
      <br />(3)为了遵从相关法律法规、部门规章、政府指令的相关要求。
      <br />3.请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
      <br />4.如果需要从第三方间接获取您的个人信息，我们会在获取前向您告知个人信息的来源、类型及使用范围，如我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您该等个人信息前征得您的授权同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保证其提供的信息的合法性。
      <br />
      <br />（二）信息的存储<br />
      <br />1.我们会通过安全的方式存储您的信息，为最大程度保护您的个人隐私，当前工具仅进行本地缓存保存，未进行任何服务器数据存储。
      <br />2.请您注意，如您选择注销您的账户，我们会删除您的信息或对其进行匿名化处理，但相关法律法规规定必须在一定期间内留存的信息除外。对于上述必须留存的信息，我们会在法律法规规定的留存期间到期后删除或进行匿名化处理。
      <br />3.我们会采取合理可行的措施，尽力避免收集无关的用户信息。除非法律允许或经另行约定，我们只会在达成本政策所述目的所需的期限内保留您的用户信息。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。
      <br />4.如出现本程序产品和服务停止运营的情况，我们会采取合理措施保护您用户信息安全，保护及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。
      <br />5.我们将收集到的您的用户信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们将向您说明具体情况并取得您的单独同意并按照中国法律法规的要求完成相应的安全评估。
      <br />
      <br />（三）信息安全保护<br />
      <br />1.我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。
      <br />2.我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。
      <br />3.在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门的要求，上报用户信息安全事件的处置情况。
      <br />
      <br />（四）信息的共享、转让、公开披露<br />
      <br />1.共享
      <br />(1)我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。
      <br />(2)为提升您的用户体验，我们可能需要向第三方合作伙伴等分享已经匿名化或去标识化处理后的信息，我们将要求其严格遵守我们关于数据保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
      <br />(3)我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
      <br />2.转让
      <br />我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
      <br />(1)在获取明确同意的情形下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。
      <br />(2)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会向您告知接收方的名称和联系方式，并要求承接持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
      <br />3.公开披露
      <br />(1)我们仅会获取你对我们小程序工具的订阅信息，对于订阅信息我们严格保密，以下情况除外：
      <br />①获得您明确、单独同意后。
      <br />②基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的信息。
      <br />(2)除上述情形外，我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
      <br />
      <br />（五）您的权利<br />
      <br />1.您可以通过微信小程序的删除功能删除我们工具，删除后并且清空微信缓存的情况下，您使用我们小程序的所有数据和记录将被彻底删除。
      <br />2.在以下情形中，您可以向我们提出删除用户信息的请求：
      <br />(1)如果我们处理用户信息的行为违反法律法规。
      <br />(2)如果我们收集、使用您的用户信息，却未征得您的明确同意。
      <br />(3)我们停止对您提供服务。
      <br />为保障安全，您可能需要提供书面请求，或以其他方式证明您的用户身份，我们可能会先要求验证自己的身份，然后再处理您的请求。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      <br />3.改变授权范围：
      <br />(1)改变或撤回敏感信息权限：您可以在设备本身操作系统中关闭地理位置、摄像头等权限改变同意范围或撤回您的授权。
      <br />(2)拒绝接受推送及营销信息：您可以在电话中明确表示拒绝或通过手机设置关闭“推送通知”。
      <br />(3)请您理解，特定的业务功能和服务将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
      <br />4.对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。在以下情形中，按照法律法规的要求，我们将无法响应您的请求：
      <br />(1)与我们履行法律法规规定的义务相关的。
      <br />(2)与国家安全、国防安全直接相关的。
      <br />(3)与公共安全、公共卫生、重大公共利益直接相关的。
      <br />(4)与刑事侦查、起诉、审判和判决等直接相关的。
      <br />(5)我们有充分证据表明您存在主观恶意或滥用权利的。
      <br />(6)响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
      <br />(7)涉及商业秘密的。
      <br />
      <br />（六）个人信息保护政策变更<br />
      <br />1.当前版本的个人信息保护政策更新日期为2022年3月22日起正式生效。
      <br />2.当本政策的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的个人信息保护政策，并向您说明生效日期。请您仔细阅读变更后的本政策内容，您继续使用我们的产品或服务即表示您同意我们按照更新后的本政策处理您的个人信息。
      <br />
      <br />（七）联系我们<br />
      <br /><div className={modStyl.section}>
          如您对本政策内容有任何疑问、意见或建议，或发现个人信息可能被泄露的，您可以通过以下方式与我们联系，一般情况下我们将在15个工作日内回复您的请求：
      </div>
      1.您可以通过小程序内部“意见反馈”或客户电话（400-995-2525）与我们联系；
      <br />2.如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向本政策签订地（上海市徐汇区）有管辖权的法院提起诉讼来寻求解决方案
      <br />
  </div>
  )
}

export default PrivacyPolicy